import { ScanSearch } from 'lucide-react';

// leak point: detection methods used (district heating / flat roof)
export default function LeakMethods({ t, obj, patch, list }) {
  const on = obj.lm || [];
  return (
    <div className="fx-box" data-testid="leak-methods">
      <b><ScanSearch size={14} /> {t.lmTitle}</b>
      <div className="chip-group">{list.map((k) => <button key={k} type="button" className={`chip seg ${on.includes(k) ? 'on' : ''}`} data-testid={`leak-method-${k}`} onClick={() => patch({ lm: on.includes(k) ? on.filter((x) => x !== k) : [...on, k] })}>{t['lm_' + k]}</button>)}</div>
    </div>
  );
}
